<template>
<div style="margin: 25px;">
    <div class="lookmember" style="min-height:500px;">
<!--        <div style="line-height: 60px;">会员类型：个人会员，您的权利剩余如下</div>-->
        <div class="looktitle">
            <span style="margin-left:25px">会员权益剩余次数明细</span>
            <!--<span style="margin-right:25px">会员类型：{{accountType}}会员，您的权益剩余如下</span>-->
            <span style="margin-right:25px">会员类型：{{medalName}}，您的权益剩余如下</span>
        </div>
        <Row class-name="look-row">
            <Col :span="8" style="text-indent:95px">
                功能
            </Col>
            <Col :span="8" style="text-indent:180px">剩余次数</Col>
            <Col :span="8" style="text-indent:242px">操作</Col>
        </Row>
        <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
                版权存证
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.evidenceArchiveNum?showList.evidenceArchiveNum:0}}次</Col>
            <Col :span="8" style="text-indent:212px">
                <input @click="jumpload('1')" type="button" value="使用" />
            </Col>
        </Row>
        <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
            电子版权登记
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.copyrightRegisterNum}}次</Col>
            <Col :span="8" style="text-indent:212px">
                <input @click="jumpload('6')" type="button" value="使用" />
            </Col>
        </Row>
        <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
            纸质版权登记
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.paperCopyrightRegisterNum}}次</Col>
            <Col :span="8" style="text-indent:212px">
                <input @click="jumpload('7')" type="button" value="使用" />
            </Col>
        </Row>
        <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
                证书查询
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.copyrightRegisterFindNum}}次</Col>
            <Col :span="8" style="text-indent:212px">
                <input @click="jumpload('7')" type="button" value="使用" />
            </Col>
        </Row>
        <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
                证书撤销
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.copyrightRegisterCancelNum}}次</Col>
            <Col :span="8" style="text-indent:212px">
                <input @click="jumpload('7')" type="button" value="使用" />
            </Col>
        </Row>
        <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
                作品变更
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.copyrightRegisterUpdateNum}}次</Col>
            <Col :span="8" style="text-indent:212px">
                <input @click="jumpload('7')" type="button" value="使用" />
            </Col>
        </Row>
        <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
                图片监测
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.imageMonitorNum?showList.imageMonitorNum:0}}次</Col>
            <Col :span="8" style="text-indent:212px">
                <input @click="jumpload('2')" type="button" value="使用" />
            </Col>
        </Row>
        <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
                音乐监测
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.musicMonitorNum?showList.musicMonitorNum:0}}次</Col>
            <Col :span="8" style="text-indent:212px">
                <input @click="jumpload('2')" type="button" value="使用" />
            </Col>
        </Row>
        <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
                文字监测
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.textMonitorNum?showList.textMonitorNum:0}}次</Col>
            <Col :span="8" style="text-indent:212px">
                <input @click="jumpload('2')" type="button" value="使用" />
            </Col>
        </Row>
        <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
                版权取证
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.forensicsNum?showList.forensicsNum:0}}次</Col>
            <Col :span="8" style="text-indent:212px">
                <input @click="jumpload('3')" type="button" value="使用" />
            </Col>
        </Row>
<!--        <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
                电子数据确认函
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.notarizationNum?showList.notarizationNum:0}}次</Col>
            <Col :span="8" style="text-indent:212px">
                <input @click="jumpload('5')" type="button" value="使用" />
            </Col>
        </Row>-->
         <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
                电话问律师30分钟
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.lawyerConsult30Num?showList.lawyerConsult30Num:0}}次</Col>
            <Col :span="8" style="text-indent:212px">
                <input @click="jumpload('4')" type="button" value="使用" />
            </Col>
        </Row>
        <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
                电话问律师60分钟
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.lawyerConsult60Num?showList.lawyerConsult60Num:0}}次</Col>
            <Col :span="8" style="text-indent:212px">
            <input @click="jumpload('4')" type="button" value="使用" />
            </Col>
        </Row>

<!--        v-if="accountType=='企业' "-->
         <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
                出具律师函
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.lawyerLetterNum?showList.lawyerLetterNum:0}}次</Col>
            <Col :span="8" style="text-indent:212px">
                <input @click="jumpload('4')" type="button" value="使用" />
            </Col>
        </Row>
        <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
                 侵权下架
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.tortShelvesNum?showList.tortShelvesNum:0}}次</Col>
            <Col :span="8" style="text-indent:212px">
            <input @click="jumpload('4')" type="button" value="使用" />
            </Col>
        </Row>
        <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
                合同审核
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.contractAuditNum?showList.contractAuditNum:0}}次</Col>
            <Col :span="8" style="text-indent:212px">
            <input @click="jumpload('4')" type="button" value="使用" />
            </Col>
        </Row>
        <Row class-name="rowcolor">
            <Col :span="8" style="text-indent:80px">
                侵权判定+维权方案设计
            </Col>
            <Col :span="8" style="text-indent:195px">{{showList.infringementDeterminationNum?showList.infringementDeterminationNum:0}}次</Col>
            <Col :span="8" style="text-indent:212px">
            <input @click="jumpload('4')" type="button" value="使用" />
            </Col>
        </Row>
        <!-- <Row class-name="rowcolor">
            <Col :span="8">
                电子公正
            </Col>
            <Col :span="8">{{showList.judicialEvidenceNum}}次</Col>
            <Col :span="8">
                <input type="button" value="使用" />
            </Col>
        </Row> -->
    </div>
    <div style="text-align:center"><button class="goBtn" @click="immediatePayment()">{{showText}}</button></div>
    <mycapay @fatherModal="fatherModal" @updateVipData='updateVipData' mywidth='838' myheight="585" myTitleheight="50" v-if="showDialog03" />
    </div>
</template>

<script>
    import {getVipMemberright} from '@/api/staticPage';
    import { userInfo} from "@/api/index";
    import Cookies from "js-cookie";
    import mycapay from './../../vip/lawcomponent/myczpay.vue';
    export default {
        metaInfo: {
            title: '剩余套餐次数|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            },{
                name: 'Description',
                content: '剩余套餐次数,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name:'lookMember',
        data(){
            return {
                showList:{},
                showDialog03:!1,
                accountType:"",
                medalName:"",
                showText:'立即续费',
                userInfo:""
            }
        },
        components:{
            mycapay
        },
        methods:{
            //续费
            fatherModal(){
                this.showDialog03 = !1
            },
            immediatePayment(){
                if(this.showText=='立即开通'){
//                    if(this.userInfo.accountType=='person'){
//                        this.$router.push({ path:'/vipPersonal' })
//                    }else if(this.userInfo.accountType=='enterprise'){
//                        this.$router.push({ path:'/vipEnterprise' })
//                    }else{
//                        this.$router.push({ path:'/' })
//                    }
                    this.$router.push({ path:'/huiyuan.html' })
                }else{
                    this.showDialog03 = !0
                }

            },
            //支付成功后更新数据
            updateVipData(){
               this._getVipMemberright()
            },
            _getVipMemberright(){
                let _this = this;
                let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                let params = {
                    registerId:userInfo && userInfo.id?userInfo.id:'',
                }
                getVipMemberright(params).then(res=>{
                    console.log('++++++++++++++++++++++',res)
                    if(res.code == 200){
                        this.showList = res.result
                    }
                })
                this.medalName =  userInfo.medalName ? userInfo.medalName : 'VIP会员';
            },
            jumpload(type){
                switch(type){
                    case '1':
                        this.$router.push({ path:'/cunzheng.html' })
                        break;
                    case '2':
                        this.$router.push({ path:'/jiance.html' })
                        break;
                    case '3':
                        this.$router.push({ path:'/evidence' })
                        break;
                    case '4':
                        this.$router.push({ path:'/fuwu.html' })
                        break;
                    case '5':
                        this.$router.push({ path:'/myExisting' })
                        break;
                    case '6':
                        this.$router.push({ path:'/copyrightRegistration' })
                        break;
                    case '7':
                        this.$router.push({ path:'/myDci' })
                        break;
                    default:
                        break;
                }
            }
        },
        mounted(){
            this._getVipMemberright()
        },
        created(){
            let _this = this;
            let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            this.userInfo = userInfo
            if(userInfo.vipFlag=="2"){
                this.accountType='试用';
                this.medalName='试用会员';
                this.showText='立即开通'
            }else{
                this.accountType =  userInfo.accountType=='person'?'个人':'企业';
                this.medalName =  userInfo.medalName ? userInfo.medalName : 'VIP会员';
                this.showText='立即续费'
            }
        },
    }
</script>

<style scoped lang="less">
    .lookmember{
        min-width:1108px;
        margin:10px auto 30px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
        border-radius:2px;
        .looktitle{
            min-width:1108px;
            height:63px;
            background:rgba(255,255,255,1);
            box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
            border-radius:2px 2px 0px 0px;
            font-size: 14px;
            color:rgba(51,51,51,1);
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .look-row{
            min-width:1108px;
            height:50px;
            line-height: 50px;
            background:rgba(251,251,251,1);
            font-size: 14px;
            color:rgba(50,50,50,1);
        }
        .rowcolor{
            min-width:1108px;
            height:65px;
            line-height: 65px;
            background:rgba(255,255,255,1);
            border-bottom:1px solid #F7F9FB;
            font-size: 14px;
            color:rgba(102,102,102,1);
            input{
                width:84px;
                height:33px;
                background:rgba(246,246,246,1);
                border-radius:2px;
                border:1px solid rgba(239,239,239,1);
                line-height:33px;
                font-size: 12px;
                color:rgba(51,51,51,1);
                outline: none;
                border: none;
                cursor: pointer;
            }
            input:hover{
                background:#FFD800;
                border:1px solid #FFD800;
            }
        }
    }
    .goBtn{
        width:230px;
        height:42px;
        line-height: 42px;
        border:0px;
        background:rgba(255,216,0,1);
        border-radius:4px;
        outline: none;
        cursor: pointer;
        font-size:14px;
        font-weight:600;
        color:rgba(78,78,78,1);
        margin-bottom: 50px;
         }
</style>
